import EcommerceProductModel from "@/Interfaces/Product/EcommerceProductModel";
import ProductModel from "@/Interfaces/Product/ProductModel";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useShoppingCartStore = defineStore('shopping-cart', () => {
    const wishListItems = ref<EcommerceProductModel[]>([]);
    const cartItems = ref<EcommerceProductModel[]>([]);
    const localStorageCartItems = ref<EcommerceProductModel[]|null>(null);
    const localStorageWishListItems = ref<EcommerceProductModel[]|null>(null);
    const visibleRight = ref(false);
    const searchProductList = ref<ProductModel[]>([]);
    const searchTerm = ref<string|null>(null);
    const dbCartItems = ref<EcommerceProductModel[]|null>(null);
    const order = ref<Object|null>(null);

    return {
        cartItems,
        localStorageCartItems,
        wishListItems,
        localStorageWishListItems,
        visibleRight,
        searchProductList,
        searchTerm,
        dbCartItems,
        order
    }
});